const axios = require('axios');
var client = axios.create();
export default {
  list: () => client.get('/articles/index.json',{
		transformResponse: [function (data) {
			return JSON.parse(data);
		}]
	}),
  get: (file) => client.get('/articles/'+file)
}
